import { db } from "../../config/firebase/firebase-config";
import { Types } from "../types/types";

export const fetchCompanyData = (idEntity: any) => {
  return async (dispatch: Function) => {
    const response = await getCompany(idEntity);
    if (response) {

      dispatch(loadCompany(response));
    }
  };
};

export const loadCompany = (data: any): any => ({
  type: Types.SUCCESS_COMPANY,
  payload: data,
});

export const getCompany = async (idEntity: any) => {
  const snap = await db
    .collection("Entities")
    .where("id", "==", idEntity)
    .limit(1)
    .get();
  if (snap.empty) {
    return null;
  }
  let response: any;

  snap.forEach((doc: any) => {
    response = doc.data() as any;
  });

  return response;
};
